import { useState } from 'react'
import toast from 'react-hot-toast'
import { AlertTriangle, BookOpen, Check, Copy, Download } from 'lucide-react'
import { useVerticalUI } from '@/lib/verticalUI'

const ORDERS_SHEETS_SCRIPT = `const SECRETO = 'PEGA_AQUI_TU_SECRETO'

function doPost(e) {
  const raw = e.postData.contents
  const headers = e.headers || {}
  const firma = (headers['X-Iridia-Signature'] || e.parameter['X-Iridia-Signature'] || '')
    .split(',')[0].replace('v1=', '')
  const timestamp = headers['X-Iridia-Timestamp'] || e.parameter['X-Iridia-Timestamp']
  const esperada = Utilities.computeHmacSha256Signature(timestamp + '.' + raw, SECRETO)
    .map(function (b) { return ('0' + (b & 0xff).toString(16)).slice(-2) }).join('')

  if (!firma || firma !== esperada) {
    return ContentService.createTextOutput('Firma inválida')
  }

  const evento = JSON.parse(raw)
  const libro = SpreadsheetApp.getActiveSpreadsheet()
  const ids = libro.getSheetByName('IDs') || libro.insertSheet('IDs')
  if (ids.getRange('A:A').getValues().flat().indexOf(evento.id) !== -1) {
    return ContentService.createTextOutput('OK')
  }

  const hoja = libro.getSheetByName('Pedidos') || libro.insertSheet('Pedidos')
  if (hoja.getLastRow() === 0) {
    hoja.appendRow(['Fecha', 'Orden', 'Cliente', 'Producto', 'Cantidad', 'Total', 'Estado'])
  }
  const orden = evento.data.order
  orden.items.forEach(function (item) {
    hoja.appendRow([
      new Date(evento.createdAt), orden.orderNumber, orden.customer.name || '',
      item.name, item.quantity, item.totalCents / 100, orden.status,
    ])
  })
  ids.appendRow([evento.id])
  return ContentService.createTextOutput('OK')
}`

const APPOINTMENTS_SHEETS_SCRIPT = `const SECRETO = 'PEGA_AQUI_TU_SECRETO'

function doPost(e) {
  const raw = e.postData.contents
  const headers = e.headers || {}
  const firma = (headers['X-Iridia-Signature'] || e.parameter['X-Iridia-Signature'] || '')
    .split(',')[0].replace('v1=', '')
  const timestamp = headers['X-Iridia-Timestamp'] || e.parameter['X-Iridia-Timestamp']
  const esperada = Utilities.computeHmacSha256Signature(timestamp + '.' + raw, SECRETO)
    .map(function (b) { return ('0' + (b & 0xff).toString(16)).slice(-2) }).join('')

  if (!firma || firma !== esperada) {
    return ContentService.createTextOutput('Firma inválida')
  }

  const evento = JSON.parse(raw)
  const cita = evento.data && evento.data.appointment
  if (!cita) return ContentService.createTextOutput('OK')

  const libro = SpreadsheetApp.getActiveSpreadsheet()
  const ids = libro.getSheetByName('IDs') || libro.insertSheet('IDs')
  if (ids.getRange('A:A').getValues().flat().indexOf(evento.id) !== -1) {
    return ContentService.createTextOutput('OK')
  }

  const hoja = libro.getSheetByName('Citas') || libro.insertSheet('Citas')
  if (hoja.getLastRow() === 0) {
    hoja.appendRow([
      'ID Cita', 'Estado', 'Cliente', 'Teléfono', 'Servicio',
      'Preferencia solicitada', 'Inicio confirmado', 'Fin confirmado',
      'Profesional', 'Ubicación / Sala', 'Actualizado'
    ])
  }

  const fila = [
    cita.id, cita.status, (cita.customer && cita.customer.name) || '',
    (cita.customer && cita.customer.phone) || '', (cita.service && cita.service.name) || '',
    (cita.requestedSlot && cita.requestedSlot.text) || '',
    (cita.confirmedSlot && cita.confirmedSlot.startAt) || '',
    (cita.confirmedSlot && cita.confirmedSlot.endAt) || '',
    (cita.staff && cita.staff.name) || '', cita.locationOrRoom || '', evento.createdAt
  ]

  const columnaIds = hoja.getRange(1, 1, Math.max(1, hoja.getLastRow()), 1).getValues().flat()
  const idx = columnaIds.indexOf(cita.id)
  if (idx > 0) {
    hoja.getRange(idx + 1, 1, 1, fila.length).setValues([fila])
  } else {
    hoja.appendRow(fila)
  }

  ids.appendRow([evento.id])
  return ContentService.createTextOutput('OK')
}`

const APPOINTMENTS_CALENDAR_SCRIPT = `const SECRETO = 'PEGA_AQUI_TU_SECRETO'

function doPost(e) {
  const raw = e.postData.contents
  const headers = e.headers || {}
  const firma = (headers['X-Iridia-Signature'] || e.parameter['X-Iridia-Signature'] || '')
    .split(',')[0].replace('v1=', '')
  const timestamp = headers['X-Iridia-Timestamp'] || e.parameter['X-Iridia-Timestamp']
  const esperada = Utilities.computeHmacSha256Signature(timestamp + '.' + raw, SECRETO)
    .map(function (b) { return ('0' + (b & 0xff).toString(16)).slice(-2) }).join('')

  if (!firma || firma !== esperada) {
    return ContentService.createTextOutput('Firma inválida')
  }

  const evento = JSON.parse(raw)
  const cita = evento.data && evento.data.appointment
  if (!cita) return ContentService.createTextOutput('OK')

  const cal = CalendarApp.getDefaultCalendar()

  // Bloquea la agenda SOLO con appointment.confirmed
  if (evento.type === 'appointment.confirmed' && cita.confirmedSlot) {
    const titulo = ((cita.service && cita.service.name) || 'Cita') +
      ' - ' + ((cita.customer && cita.customer.name) || 'Cliente')
    const ev = cal.createEvent(
      titulo,
      new Date(cita.confirmedSlot.startAt),
      new Date(cita.confirmedSlot.endAt),
      {
        location: cita.locationOrRoom || '',
        description: 'Teléfono: ' + ((cita.customer && cita.customer.phone) || '') +
          '\\nID Cita: ' + cita.id
      }
    )
    ev.setTag('iridiaAppointmentId', cita.id)
  }

  if (evento.type === 'appointment.cancelled' || evento.type === 'appointment.rescheduled') {
    const desde = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
    const hasta = new Date(Date.now() + 90 * 24 * 60 * 60 * 1000)
    cal.getEvents(desde, hasta, { search: cita.id }).forEach(function (ev) {
      if (ev.getTag('iridiaAppointmentId') === cita.id) ev.deleteEvent()
    })
  }

  return ContentService.createTextOutput('OK')
}`

function ScriptActions({
  value,
  copyLabel,
  fileName,
}: {
  value: string
  copyLabel: string
  fileName: string
}) {
  const [copied, setCopied] = useState(false)

  async function copy() {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      toast.success('Copiado')
    } catch {
      toast.error('No se pudo copiar. Selecciona el texto manualmente.')
    }
  }

  function download() {
    try {
      const blob = new Blob([value], { type: 'text/plain;charset=utf-8' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    } catch {
      toast.error('No se pudo descargar el archivo.')
    }
  }

  return (
    <div className="mt-2 flex flex-wrap items-center gap-2">
      <button
        type="button"
        onClick={() => void copy()}
        aria-label={copyLabel}
        className="inline-flex items-center gap-1.5 rounded-md border border-gray-300 bg-white px-2.5 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50"
      >
        {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
        {copied ? 'Copiado' : 'Copiar script'}
      </button>
      <button
        type="button"
        onClick={download}
        aria-label={`Descargar ${fileName}`}
        className="inline-flex items-center gap-1.5 rounded-md border border-gray-300 bg-white px-2.5 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50"
      >
        <Download className="h-3.5 w-3.5" />
        Descargar .gs
      </button>
    </div>
  )
}

export function WebhookHelpSection() {
  const { profile } = useVerticalUI()
  const isAppointmentVertical = Boolean(profile.nav.showAppointments && !profile.nav.showOrders)
  const pluralAppointmentLabel = isAppointmentVertical
    ? profile.terminology.primaryTransactionPlural.toLowerCase()
    : 'citas'

  return (
    <section
      className="mt-6 rounded-xl border border-gray-200 bg-white p-4 sm:p-5"
      aria-labelledby="webhook-help-title"
    >
      <div className="flex items-center gap-2">
        <BookOpen className="h-4 w-4 text-gray-500" aria-hidden="true" />
        <h2 id="webhook-help-title" className="text-sm font-semibold text-gray-900">
          Cómo conectar tu sistema
        </h2>
      </div>

      <div className="mt-3 flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 p-3 text-xs text-amber-900">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" aria-hidden="true" />
        <p>
          <code className="rounded bg-amber-100 px-1 font-mono">appointment.requested</code> es una
          solicitud: el cliente pidió ese horario, pero nadie lo confirmó. Bloquea la agenda solo
          con <code className="rounded bg-amber-100 px-1 font-mono">appointment.confirmed</code>.
        </p>
      </div>

      <details className="mt-3 border-t border-gray-100 pt-3" open={isAppointmentVertical}>
        <summary className="cursor-pointer text-sm font-medium text-gray-800">
          Google Sheets ({pluralAppointmentLabel})
        </summary>
        <ol className="mt-2 list-decimal space-y-1 pl-5 text-xs text-gray-600">
          <li>Abre tu hoja y entra en Extensiones → Apps Script.</li>
          <li>
            Pega el script, cambia <code className="rounded bg-gray-100 px-1">SECRETO</code> y
            guárdalo. El script actualiza la misma fila cuando la solicitud pasa a confirmada,
            reprogramada o cancelada.
          </li>
          <li>
            Implementar → Nueva implementación → Aplicación web; ejecuta como tú y acceso para
            cualquiera.
          </li>
          <li>
            Copia la URL terminada en <code className="rounded bg-gray-100 px-1">/exec</code> y
            pégala en un destino nuevo.
          </li>
        </ol>
        <pre className="mt-2 max-h-72 overflow-auto rounded-lg bg-gray-950 p-3 text-[11px] leading-relaxed text-gray-100">
          <code>{APPOINTMENTS_SHEETS_SCRIPT}</code>
        </pre>
        <ScriptActions
          value={APPOINTMENTS_SHEETS_SCRIPT}
          copyLabel="Copiar script de Google Sheets para citas"
          fileName="iridia-citas-sheets.gs"
        />
      </details>

      <details className="mt-3 border-t border-gray-100 pt-3">
        <summary className="cursor-pointer text-sm font-medium text-gray-800">
          Google Calendar (bloquear horario al confirmar)
        </summary>
        <ol className="mt-2 list-decimal space-y-1 pl-5 text-xs text-gray-600">
          <li>
            En Apps Script, pega este código y configura tu{' '}
            <code className="rounded bg-gray-100 px-1">SECRETO</code>.
          </li>
          <li>
            Crea el evento en tu calendario únicamente cuando llega{' '}
            <code className="rounded bg-gray-100 px-1">appointment.confirmed</code> y lo elimina si
            se cancela o reprograma.
          </li>
        </ol>
        <pre className="mt-2 max-h-72 overflow-auto rounded-lg bg-gray-950 p-3 text-[11px] leading-relaxed text-gray-100">
          <code>{APPOINTMENTS_CALENDAR_SCRIPT}</code>
        </pre>
        <ScriptActions
          value={APPOINTMENTS_CALENDAR_SCRIPT}
          copyLabel="Copiar script de Google Calendar"
          fileName="iridia-citas-calendar.gs"
        />
      </details>

      <details className="mt-3 border-t border-gray-100 pt-3">
        <summary className="cursor-pointer text-sm font-medium text-gray-800">
          Google Sheets (pedidos)
        </summary>
        <ol className="mt-2 list-decimal space-y-1 pl-5 text-xs text-gray-600">
          <li>Abre tu hoja y entra en Extensiones → Apps Script.</li>
          <li>
            Pega el script, cambia <code className="rounded bg-gray-100 px-1">SECRETO</code> y
            guárdalo.
          </li>
          <li>
            Implementar → Nueva implementación → Aplicación web; ejecuta como tú y acceso para
            cualquiera.
          </li>
          <li>
            Copia la URL terminada en <code className="rounded bg-gray-100 px-1">/exec</code> y
            pégala en un destino nuevo.
          </li>
        </ol>
        <pre className="mt-2 max-h-72 overflow-auto rounded-lg bg-gray-950 p-3 text-[11px] leading-relaxed text-gray-100">
          <code>{ORDERS_SHEETS_SCRIPT}</code>
        </pre>
        <ScriptActions
          value={ORDERS_SHEETS_SCRIPT}
          copyLabel="Copiar script de Google Sheets"
          fileName="iridia-pedidos-sheets.gs"
        />
      </details>

      <details className="mt-3 border-t border-gray-100 pt-3">
        <summary className="cursor-pointer text-sm font-medium text-gray-800">
          Excel Online, Outlook y Power Automate
        </summary>
        <ol className="mt-2 list-decimal space-y-1 pl-5 text-xs text-gray-600">
          <li>
            Crea un flujo con el disparador “Cuando se recibe una solicitud HTTP” (método POST).
          </li>
          <li>
            Añade “Agregar o actualizar una fila” de Excel Online y mapea los campos de{' '}
            <code className="rounded bg-gray-100 px-1">data.appointment</code> o{' '}
            <code className="rounded bg-gray-100 px-1">data.order</code>.
          </li>
          <li>
            Para bloquear Outlook Calendar, filtra por{' '}
            <code className="rounded bg-gray-100 px-1">type = appointment.confirmed</code>.
          </li>
          <li>Copia la URL del disparador y pégala en un destino nuevo.</li>
        </ol>
      </details>

      <details className="mt-3 border-t border-gray-100 pt-3">
        <summary className="cursor-pointer text-sm font-medium text-gray-800">
          Zapier, Make o n8n
        </summary>
        <p className="mt-2 text-xs text-gray-600">
          Usa el disparador “Webhook / Catch Hook”, pega la URL en un destino nuevo y elige la acción
          de destino. Guarda el campo <code className="rounded bg-gray-100 px-1">id</code> para
          descartar avisos repetidos.
        </p>
      </details>
    </section>
  )
}
